@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: grid;
    grid-auto-flow: column dense;
    gap: var(--spacer-24) var(--labui-grid-gap);

    @media ($below-mobile) {
        display: flex;
        flex-direction: column;
    }

    &.twoRows {
        grid-template-areas:
            ". featured ."
            ". featured .";
    }

    &.oneRow {
        grid-template-rows: 1fr;
    }
}

.twoColumns {
    composes: root;
    grid-template-columns: repeat(2, 1fr);
}

.threeColumns {
    composes: root;
    grid-template-columns: repeat(3, 1fr);
}

.card {
    grid-column: span 1;
    font: var(--font-p-18);

    &:hover {
        color: var(--red);
    }
}

.featuredCard {
    composes: card;
    grid-area: featured;

    > article {
        height: 100%;
    }
}

.featuredClickable {
    @media ($above-mobile) {
        display: flex;
        flex-direction: column;
        height: 100%;
    }
}

.pictureBase {
    display: block;
    width: 100%;
    overflow: hidden;
    margin-bottom: var(--spacer-16);

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.picture {
    composes: pictureBase;
    aspect-ratio: 21 / 10;
}

.featuredPicture {
    composes: pictureBase;
    flex-grow: 1;

    @media ($below-mobile) {
        aspect-ratio: 21 / 10;
    }
}

.minHeight {
    min-height: var(--spacer-80);
}

.cta {
    composes: fontUppercase from "../../styles/composable/typography.module.css";
    display: flex;
    align-items: center;
    gap: var(--spacer-4);
    margin-top: var(--spacer-8);
    font: var(--font-eyebrow);
}

.svg {
    width: 16px;
    height: 16px;
    translate: 0 -2px;
}
